import { ImpactPartnerInfo } from '@platform/client/schemas';
import { Icon } from '@platform/components';
import { H2 } from '../landing/utils';
import {
  getOpportunityIntro,
  opportunityChecklist,
  partnerLandingImages,
} from './partnerLandingContent';

type PartnerLandingOpportunitySectionV2Props = {
  partner: ImpactPartnerInfo;
};

export const PartnerLandingOpportunitySectionV2 = ({
  partner,
}: PartnerLandingOpportunitySectionV2Props) => {
  return (
    <section className='px-4 py-16 sm:px-8 sm:py-20'>
      <div className='mx-auto grid max-w-[1216px] gap-8 lg:grid-cols-2 lg:items-center lg:gap-12'>
        <div className='order-2 overflow-hidden rounded-lg lg:order-1'>
          <img
            src={partnerLandingImages.opportunity}
            alt={`${partner.name} opportunity`}
            width={635}
            height={424}
            className='h-auto w-full max-w-[635px] object-cover'
          />
        </div>
        <div className='order-1 lg:order-2'>
          <H2>Why you&apos;re receiving this opportunity</H2>
          <p className='mt-5 text-xl leading-7 text-gray-500'>
            {getOpportunityIntro(partner)}
          </p>
          <div className='mt-8 flex flex-col gap-4'>
            {opportunityChecklist.map((item) => (
              <div key={item} className='flex items-start gap-3'>
                <div className='mt-0.5 shrink-0 text-success-500'>
                  <Icon type='check-circle' size='24' />
                </div>
                <p className='text-xl leading-7 text-gray-500'>
                  {item}
                </p>
              </div>
            ))}
          </div>
          <p className='mt-8 text-xl leading-7 text-gray-500'>
            MovingWorlds supports you through a simple, guided process—connecting you with the
            right people, partners, and opportunities to move your business forward.
          </p>
        </div>
      </div>
    </section>
  );
};
